export default __webpack_public_path__ + "static/media/04.a077e6b3.png";